import type { DistributionListMember } from '../../shared';

export const NoEmailAddressWrapper = '_NoEmailAddressWrapper';
export const NoMailboxTypeInWrapper = '_NoMailboxTypeInWrapper';

export function getMailBoxTypeFromPDLMember(member: DistributionListMember): string {
    return member.emailAddressWrapper
        ? member.emailAddressWrapper.MailboxType
            ? member.emailAddressWrapper.MailboxType.toString()
            : NoMailboxTypeInWrapper
        : NoEmailAddressWrapper;
}

export function getKeysFromPDLMemberEmailWrapper(member: DistributionListMember): string {
    const wrapper = member.emailAddressWrapper;
    return wrapper && typeof wrapper !== 'string'
        ? Object.keys(wrapper)
              .filter(key => wrapper[key])
              .toString()
        : NoEmailAddressWrapper;
}
